import { Box, Button, Typography } from "@mui/material";
import { BG, LINE, MUTED, TEXT, btnPlain, btnPrimary, kbdSx, pillSx } from "./editorTheme";
import { fmtArea } from "./editorModel";
import { useEditorData } from "./useEditorData";
import { useEditorActions } from "./useEditorActions";
import { useVegEditor } from "./VegEditorContext";

/** The strip under the top bar while the editor is open: where you are
 *  (Vegetation › this refinement · its area), Review changes, Exit. It
 *  stands where the strategies bar normally does and is the same height. */
export default function VegEditorBar() {
  const { phase, sheet, setSheet } = useVegEditor();
  const d = useEditorData();
  const a = useEditorActions();
  const job = d.job;
  const accepted = Object.values(d.groups).reduce((n, g) => n + g.accepted, 0);
  const canReview = phase === "session" && !!job && job.status !== "failed" && (accepted > 0 || d.isClean);
  const areaLabel = job ? `${job.area && d.projectAreaM2 && Math.abs(d.jobAreaM2 - d.projectAreaM2) / d.projectAreaM2 < 0.02 ? "Whole project" : "Drawn area"} · ${fmtArea(d.jobAreaM2)}` : "";
  return (
    <Box sx={{ height: "var(--strategies-h)", bgcolor: BG, borderBottom: `1px solid ${LINE}`, display: "flex", alignItems: "center", gap: 1.5, px: 2, color: TEXT, flex: "none" }}>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, minWidth: 0, flex: 1 }}>
        <Typography sx={{ fontSize: 13, fontWeight: phase === "session" ? 400 : 600, color: phase === "session" ? MUTED : TEXT, whiteSpace: "nowrap" }}>Vegetation</Typography>
        {phase === "setup" && (<><Typography sx={{ color: MUTED }}>/</Typography><Typography sx={{ fontSize: 13, fontWeight: 600, whiteSpace: "nowrap" }}>New refinement</Typography></>)}
        {phase === "session" && job && (
          <>
            <Typography sx={{ color: MUTED }}>/</Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, whiteSpace: "nowrap" }}>{job.name}</Typography>
            <Typography sx={{ fontSize: 12, color: MUTED, whiteSpace: "nowrap" }}>{areaLabel}</Typography>
            {d.isClean && <Box sx={pillSx()}>Clean slate</Box>}
            {job.status === "failed" && <Box sx={pillSx()}>Failed</Box>}
          </>
        )}
      </Box>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        {canReview && (
          <Button sx={btnPrimary} onClick={() => setSheet(sheet === "changes" ? null : "changes")}>
            Review changes{accepted > 0 && <Box component="span" sx={{ ...kbdSx, ml: 0.75, bgcolor: "rgba(6,48,42,0.18)", borderColor: "rgba(6,48,42,0.35)", color: "#06302a" }}>{accepted}</Box>}
          </Button>
        )}
        <Button sx={btnPlain} onClick={a.exit}>Exit</Button>
      </Box>
    </Box>
  );
}
